import { useState } from 'react'
import authApiService from '../services/authApi.js'
import '../styles/login.css'

function Login({ onLoginSuccess }) {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    try {
      const response = await authApiService.login(username, password)

      if (response.status === 'success') {
        // Call the success callback (storage is handled in App.jsx)
        onLoginSuccess(response)
      } else {
        setError('Invalid username or password')
      }
    } catch (err) {
      console.error('Login error:', err)
      setError('Login failed. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="login-container">
      <div className="login-left-section" style={{ backgroundImage: 'url(./atmantan-bg.png)' }}>
        <img src="./atmantan-text-logo.svg" alt="Āt Mantan" className="login-brand-logo" />
      </div>
      
      <div className="login-right-section">
        <div className="login-form-container">
          <div className="login-form-header">
            <h2>Menu Maker Login</h2>
          </div>
          
          <form className="login-form" onSubmit={handleSubmit}>
          
                            <div className="form-group">
                              <label htmlFor="username">User name</label>
                              <input
                                type="text"
                                id="username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                placeholder="Enter username"
                                required
                                disabled={loading}
                              />
                            </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              required
              disabled={loading}
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? (
              <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', fontWeight: 'normal' }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ animation: 'spin 1s linear infinite' }}>
                  <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeDasharray="32" strokeDashoffset="32" opacity="0.3"/>
                  <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeDasharray="32" strokeDashoffset="16"/>
                </svg>
                Logging in...
              </span>
            ) : 'Login'}
          </button>
          </form>
        </div>
      </div>
      <div className="login-version">v 1.1</div>
    </div>
  )
}

export default Login

